export default "__VITE_ASSET__DczHBStu__"